import { connect } from 'react-redux';
import { Card, Row, Col } from 'react-bootstrap';
import BaseFeature from './BaseFeature';
import { PWM_DIM } from '../../../../../../utils/constantFeatures';
import PropertyDropdown from './components/PropertyDropdown';
import { Trans } from 'react-i18next';

class PWMDim extends BaseFeature {

    constructor(props) {
        super(props);

        this.state = {

        };

        this.handleChange = this.handleChange.bind(this);

    }

    handleChange(propertyName, value) {
        const v = value;
        const newState = {[propertyName]:value};
        this.setState(newState);
        this.props.handleChange(propertyName, v);
    }

    render() {
        return (
            <><Row>
                <Col lg={4} md={4} sm={12}>
                    <Card className="card-feature-component" style={{ width: '100%'}}>
                        <div className="card-header-feature">
                            {<Trans i18nKey="PWM_Dim" />}
                        </div>
                        <Card.Body className="card-body-feature" style={{ paddingTop: '0.75rem'}} >
                            <PropertyDropdown
                                translate={true}
                                property={this.props.properties[PWM_DIM.dimmingLogic]}
                                properties={this.props.properties[PWM_DIM.dimmingLogic].valueMeta.availableValues}
                                title={this.props.properties[PWM_DIM.dimmingLogic].info.displayName}
                                measureUnit={''}
                                step={1}
                                handleChange={this.handleChange}
                                dropdownStyle={{padding: '0px', display: 'flex', justifyContent: 'flex-end'}}
                                titleSize={6}
                                dropdownSize={6} />

                        </Card.Body>
                    </Card>
                </Col>

            </Row></>
        );
    }

}

export default connect(
    // mapStateToProps,
    // mapDispatchToProps
)(PWMDim);
